<template>
    <div class="header w3-card-4">
        <span class="header-text">{{ headerText }}</span>
    </div>
</template>

<script>
export default {
    props: ['headerText']
}
</script>

<style>
.header {
    background-image: url("../assets/coffee-beans-on-burlap.jpg");
    background-size: cover;
    background-blend-mode: multiply;
    background-color: #6F4E37;
    padding: 1em;
}

.header img {
    max-height: 8em;
    padding-left: 2em;
    padding-right: 2em;
    float: left;
}


.header-text {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-weight: bold;
    font-size: 4em;
    color: #FBF0E5;
    text-align: center;
}

</style>